/**
 * @generated SignedSource<<b8c9bbd7d79e196a232d218faf26e9b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestMoreImages_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "RequestMoreImages_user";
};
export type RequestMoreImages_user$key = {
  readonly " $data"?: RequestMoreImages_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestMoreImages_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestMoreImages_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b460ba4e7ff1e9f8442aef3ab59a5160";

export default node;
